// Export things like public API, and interfaces from here.
export * from './src/types';
export { TranscriptComponent } from './src/transcript.component';
